import React, { useState, useEffect, useCallback } from 'react';
import Pagination from 'react-js-pagination';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { nguoiPhoiHopPagingAction, deleteNguoiPhoiHopAction, filterListNguoiPhoiHop } from '../../store/reducers/nguoiphoihop';
import Table from 'react-bootstrap/Table';
import { toast } from 'react-toastify';
import { createUrlWithParam } from '../../utils/helper';
import { URI_INTERNAL } from '../../utils/pathLocations';
import { objectShowNumber, messageToast } from '../../utils/define';
import { ConfirmModal } from '../../modules/modal/ConfirmModal';
import { Dropdown } from 'react-bootstrap';


const NguoiPhoiHop = () => {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    // defensive selectors (use optional chaining to avoid runtime errors if reducers missing)
    const valueSearch = useSelector((state) => state.search?.valueSearch || '');
    const total = useSelector((state) => state.nguoiPhoiHop?.totalNguoiPhoiHop || 0);
    const list = useSelector((state) => state.nguoiPhoiHop?.listNguoiPhoiHop || []);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    const fetchData = useCallback(
        async (Page, Size, Search) => {
            const model = { Keyword: Search, PageIndex: Page, PageSize: Size };
            try {
                await dispatch(nguoiPhoiHopPagingAction(model));
            } catch (e) {
                // swallow errors from action
            }
            try {
                const url = createUrlWithParam ? createUrlWithParam(URI_INTERNAL.NGUOIPHOIHOP_PATH, { page: Page, size: Size, search: Search }) : URI_INTERNAL.NGUOIPHOIHOP_PATH;
                history.replace(url);
            } catch (e) {
                // ignore history replace errors
            }
        },
        [dispatch, history]
    );

    // parse URL
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const pageParam = parseInt(params.get('page') || 1, 10);
        const sizeParam = parseInt(params.get('size') || 20, 10);
        const searchParam = params.get('search') || '';

        if (pageParam !== page) setPage(pageParam);
        if (sizeParam !== pageSize) setPageSize(sizeParam);
        if (searchParam !== search) setSearch(searchParam);

        fetchData(pageParam, sizeParam, searchParam);
    }, [location.search, fetchData]);

    useEffect(() => {
        if (valueSearch && valueSearch !== search) {
            setSearch(valueSearch);
            fetchData(1, pageSize, valueSearch);
            setPage(1);
        }
    }, [valueSearch, pageSize, search, fetchData]);

    const changePage = (number) => {
        setPage(number);
        fetchData(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        const newSize = parseInt(e.target.value, 10);
        setPageSize(newSize);
        fetchData(page, newSize, search);
    };

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (!idWantDelete) return;
        try {
            const result = await dispatch(deleteNguoiPhoiHopAction(idWantDelete));
            if (result?.payload && result.payload.errors) {
                const errMsg = result.payload.errors?.content?.[0] || JSON.stringify(result.payload.errors);
                toast.error(errMsg);
            } else if (result?.payload === 200) {
                try { await dispatch(filterListNguoiPhoiHop(idWantDelete)); } catch (e) {}
                toast.success(messageToast.messageToastDeleteSuccess);
                fetchData(page, pageSize, search);
            } else {
                toast.error(messageToast.messageToastDeleteError);
            }
        } catch (error) {
            toast.error(messageToast.messageToastTryCatch);
        }
        setOpenConfirmDeleteModal(false);
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">Danh sách Người phối hợp</h3>
                        </div>
                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-2">
                                <form className="form-inline">
                                    <label className="mr-2">Hiển thị :</label>
                                    <select className="form-control" value={pageSize} onChange={onChangeShowNumber}>
                                        {objectShowNumber.map((item, key) => (
                                            <option key={key} value={item.value}>{item.text}</option>
                                        ))}
                                    </select>
                                </form>
                                <div className="d-flex align-items-center">
                                    <NavLink className="nav-link-reject nav-link" to={URI_INTERNAL.NGUOIPHOIHOP_CREATE_PATH}>
                                        <button type="button" className="btn btn-info">Thêm mới</button>
                                    </NavLink>
                                </div>
                            </div>

                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>STT</th>
                                        <th>Tên</th>
                                        {/*<th>Số điện thoại</th>*/}
                                        <th>Chức năng</th>
                                    </tr>
                                </thead>
                                {list && list.length > 0 ? (
                                    <tbody>
                                        {list.map((item, index) => (
                                            <tr key={item.id}>
                                                <td>{index + 1 + (page - 1) * pageSize}</td>
                                                <td>{item.name || item.hoTen || item.ten}</td>
                                                {/*<td>{item.phone || item.soDienThoai || ''}</td>*/}
                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                                                    <div className="d-flex justify-content-center">
                                                        <Dropdown align="end">
                                                            <Dropdown.Toggle
                                                                variant="outline-secondary"
                                                                size="sm"
                                                                id={`nguoiphoihop-actions-${item.id}`}
                                                                className="d-inline-flex align-items-center justify-content-center"
                                                                style={{ minWidth: 92, whiteSpace: 'nowrap' }}
                                                            >
                                                                Thao tác
                                                            </Dropdown.Toggle>

                                                            <Dropdown.Menu>
                                                                <Dropdown.Item
                                                                    as={NavLink}
                                                                    to={createUrlWithParam(URI_INTERNAL.NGUOIPHOIHOP_EDIT_PATH, { id: item.id })}
                                                                    exact
                                                                >
                                                                    Sửa
                                                                </Dropdown.Item>

                                                                <Dropdown.Divider />

                                                                <Dropdown.Item
                                                                    as="button"
                                                                    className="w-100 text-left text-danger"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        deleteAction(item.id, item.name || item.hoTen || item.ten);
                                                                    }}
                                                                >
                                                                    Xóa
                                                                </Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                ) : (
                                    <tbody>
                                        <tr className="txt-center">
                                            <td colSpan="4">Không có dữ liệu</td>
                                        </tr>
                                    </tbody>
                                )}
                            </Table>

                            <div className="dataTables_paginate paging_simple_numbers">
                                <Pagination
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    innerClass="pagination pagination-sm no-margin pull-right"
                                    activePage={page}
                                    itemsCountPerPage={Number(pageSize)}
                                    totalItemsCount={total}
                                    pageRangeDisplayed={5}
                                    onChange={changePage}
                                />
                            </div>

                            <ConfirmModal
                                isOpen={openConfirmDeleteModal}
                                confirmType="delete"
                                handleAccept={acceptDelete}
                                handleCancel={cancelDelete}
                                content={confirmDelMessage}
                            />

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NguoiPhoiHop;
